import { render } from "./DialogView.vue?vue&type=template&id=27308af8&scoped=true"
import script from "./DialogView.vue?vue&type=script&lang=js"
export * from "./DialogView.vue?vue&type=script&lang=js"

import "./DialogView.vue?vue&type=style&index=0&id=27308af8&scoped=true&lang=scss"

import exportComponent from "C:\\repos\\1File_WebClient\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27308af8"]])

export default __exports__